
import Model from '@/models/Model'

export default class PosDetailCustomerReceivablePayment extends Model {
    resource() {
        return 'pos_payments_customer_receivable_payment'
    }
}